import { Grid, TextField } from "@material-ui/core";
import { Button } from "@mui/material";
import Modal from "components/modal/Modal";
import Select from "components/select/Select";
import { STATUS_TICKET_OPTIONS } from "constant";
import { useFormik } from "formik";
import { RequiredField } from "pages/agent-chat-ticket/ticket";
import { useDispatch } from "react-redux";
import { updateTicketByNumber } from "redux/telesale/call";
import { getSelectFieldProps, getTextFieldProps } from "ultis/form";
import * as Yup from "yup";

const UpdateTicketModal = ({ open, onClose, title, data }) => {
  const dispatch = useDispatch();
  const handleSubmitUpdateTicket = (values) => {
    // values.description = values.description.replace(/\n/g, "<br>");
    dispatch(
      updateTicketByNumber(
        data.id,
        {
          description: values.description.replace(/\n/g, "<br>"),
          status: values.status,
        },
        onClose
      )
    );
  };

  const validationSchemaUpdateTicket = Yup.object().shape({
    description: Yup.string().required("Không được trống"),
    status: Yup.string().required("Không được trống"),
  });

  const formUpdateTicket = useFormik({
    initialValues: {
      description: data?.description.replace(/<br>/g, "\n") || "",
      status: data?.status || "",
    },
    onSubmit: handleSubmitUpdateTicket,
    validationSchema: validationSchemaUpdateTicket,
  });

  return (
    <Modal open={open} title={title} onClose={onClose} maxWidth="sm">
      <form onSubmit={formUpdateTicket.handleSubmit}>
        <div
          style={{
            padding: "0px 10px 10px 10px",
          }}>
          <Grid container>
            <Grid item xs={12}>
              <div style={{ marginBottom: "4px" }}>
                <span>Chi tiết yêu cầu: </span>
                <RequiredField />
              </div>
              <TextField
                variant="outlined"
                fullWidth
                multiline
                InputProps={{
                  spellCheck: "false",
                }}
                rows={3}
                {...getTextFieldProps(formUpdateTicket, "description")}
              />
            </Grid>
            <Grid item xs={12} md={4} style={{ marginTop: "10px" }}>
              <div style={{ marginBottom: "4px" }}>
                <span>Trạng thái: </span>
                <RequiredField />
              </div>
              <Select
                {...getSelectFieldProps(formUpdateTicket, "status")}
                // label="Loại báo cáo kinh doanh"
                options={STATUS_TICKET_OPTIONS?.map((item) => ({
                  value: item.value,
                  label: item.label,
                }))}
              />
            </Grid>
            <Grid item xs={12} mt={2} style={{ marginTop: "20px" }}>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <Button variant="contained" color="primary" type="submit">
                  Update ticket
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateTicketModal;
